import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Button, FormControlLabel, Checkbox, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { jobServices } from '../../services/jobServices';

const JobCheckList = ({ open, onClose, existingData, isCheckListChecked, onSave, jobType }) => {
  const [errorMessage, setErrorMessage] = useState(""); 
  const [categories, setCategories] = useState([]);
  const [temporaryCategories, setTemporaryCategories] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // Get existing data when modal is opened
  useEffect(() => {
    if (open) {
      if(existingData){
        setCategories(existingData.categories || existingData);
        setTemporaryCategories(existingData.categories || existingData);
        
      } else {
        const jobTypes = jobType === "Statutory/Final Accounts" ? jobType.replace("Statutory/","").replace(" ","") : jobType;
       
        jobServices.getBookKeepingAndVATCheckList(jobTypes).then((response) => {
            setCategories(response || []);  
            setTemporaryCategories(response || []);
          })
          .catch((error) => {
            setErrorMessage('Error in Data');
          });
      } 
    }
  }, [open, existingData]);

  const handleActionChange = (index, categoryIndex, value) => {
    const updatedTasks = [...temporaryCategories];
    updatedTasks[categoryIndex].data[index].action = value;
    setTemporaryCategories(updatedTasks);
  };

  const handleRemarksChange = (categoryIndex, index, value) => {
    const updatedTasks = [...temporaryCategories];
    updatedTasks[categoryIndex].data[index].remarks = value;
    setTemporaryCategories(updatedTasks);
  };

  // Save action
  const handleSave = () => {
    setCategories([...temporaryCategories]);
    const updatedData = {
      categories,
    };
    onSave(updatedData, true); 
    setSnackbarMessage("Data Saved Successfully!");
    setSnackbarSeverity('success');
    setOpenSnackbar(true);
    setTimeout(() => {
      setSnackbarMessage(null);
      setOpenSnackbar(false);
    }, 2000);
  };

  const onCloseModal = () => {
    setTemporaryCategories([...categories]);
    onClose();
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <React.Fragment>

      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={4000} 
        onClose={handleCloseSnackbar} 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={onCloseModal}
        slotProps={{ paper: { className: 'modern-dialog' } }}
        maxWidth="md"
        fullWidth
        aria-labelledby="checklist-dialog-title"
      >
        <DialogTitle id="checklist-dialog-title" className="modern-dialog-title">
          <span className="modern-dialog-title-text">{jobType} Checklist</span>
          <IconButton
            aria-label="close"
            onClick={onCloseModal}
            className="modern-dialog-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="modern-dialog-content">
          <Box sx={{ mt: 2 }}>
            {temporaryCategories.map((category, categoryIndex) => (
              <Box key={categoryIndex} sx={{ mb: 4 }}>
                {category.category !== "None" && (
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'var(--primary)' }}>
                    {category.category}
                  </Typography>
                )}

                <Box sx={{ overflowX: 'auto', width: '100%', borderRadius: '0.5rem', border: '1px solid #e2e8f0', mb: 2 }}>
                  <table className="checklist-table" style={{ border: 'none', margin: 0 }}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Particular</th>
                      <th>Action & Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.no}</td>
                        <td>
                          <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                            {item.particuler}
                          </Typography>
                          <TextField
                            label="Remarks"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={item.remarks}
                            onChange={(e) => handleRemarksChange(categoryIndex, index, e.target.value)}
                            placeholder="Add remarks"
                            multiline
                            rows={1}
                            sx={{
                              backgroundColor: '#fdfdfd',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0.5rem'
                              }
                            }}
                          />
                        </td>
                        <td style={{ verticalAlign: 'top' }}>
                          <FormControlLabel
                            label="Yes"
                            control={
                              <Checkbox
                                checked={item.action}
                                onChange={(e) => handleActionChange(index, categoryIndex, e.target.checked)}
                                color="primary"
                              />
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </Box>
              </Box>
            ))}
          </Box>
        </DialogContent>

        <DialogActions className="modern-dialog-actions" sx={{ flexDirection: { xs: 'row !important', sm: 'row' }, gap: { xs: 2, sm: 0 }, '& > button': { flex: { xs: 1, sm: 'none' }, margin: { xs: '0 !important', sm: '' } } }}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={onCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default JobCheckList;
